export default __webpack_public_path__ + "static/media/bernardo.4907b360.png";